import * as ActionTypes from './StylingUserActionTypes';
import { IStylingUser, IMetaData } from '../Entities';
import StylingFirmApi from '../api/StylingUsersApi';

function getStylingUsersSuccess(StylingFirms: IStylingUser[]) {
    return {
        type: ActionTypes.GET_STYLING_USERS_SUCCESS,
        result: StylingFirms
    };
}

export function getStylingUsers() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        StylingFirmApi.getStylingUsers().then((result: IStylingUser[]) => {
            dispatch(getStylingUsersSuccess(result));
        });
}

function getStylingUserSuccess(StylingUser: IStylingUser) {
    return { type: ActionTypes.GET_STYLING_USER_SUCCESS, result: StylingUser };
}

export function getStylingUser(id: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        StylingFirmApi.getStylingUser(id).then((result: IStylingUser) => {
            dispatch(getStylingUserSuccess(result));
        });
}

export function createStylingUser(user: IStylingUser) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        StylingFirmApi.createStylingUser(user).then((result: IStylingUser) => {
            dispatch({
                type: ActionTypes.SAVE_STYLING_USER_SUCCESS,
                result: result
            });
        });
}

export function updateStylingUser(user: IStylingUser) {
    return (dispatch: (result: any) => void, getState: () => any) =>
        StylingFirmApi.updateStylingUser(user).then((returnuser: IStylingUser) => {
            dispatch({
                type: ActionTypes.SAVE_STYLING_USER_SUCCESS,
                result: returnuser
            });
        });
}

export function deleteStylingUser(userId: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        StylingFirmApi.deleteStylingUser(userId).then((result: IStylingUser) => {
            dispatch({
                type: ActionTypes.REMOVED_STYLING_USER_SUCCESS,
                result: userId
            });
        });
}

export function loadMetadata() {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        StylingFirmApi.loadMetaData().then((result: IMetaData) => {
            dispatch({
                type: ActionTypes.STYLING_USER_LOAD_METADATA_SUCCESS,
                result: result
            });
        });
}
